import React from 'react'
import ResultItem from '../../../../pack/form/result/ResultItem'
import { getWorkPlaceTypeWork } from '../../../../../helpers/workPlace/WorkPlaceHelper'
import UserWorkPlaceConfirm from '../UserWorkPlaceConfirm'
import { useState } from 'react'

const UserWorkPlaceResult = ({ result }) => {

    const [open, setOpen] = useState(true)

  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>Перевірте отримані дані і погодьтеся з ними</p>
        <div className='packResultBlock__list'>
            <ResultItem
                text='Місце фіксації'
                // value={getWorkPlaceType({ type: result.type })}
                // value={result && result.department ? result.department.typeName : ''}
                value={result && result.department && result.department.type ? result.department.type.name : ''}
            />
            <ResultItem
                // text='Назва (повна)'
                text='Назва'
                value={result && result.department ? result.department.name : ''}
            />
            {/* <ResultItem
                text='Назва (коротка)'
                value={result && result.department ? result.department.slug : ''}
            /> */}
            <ResultItem
                text='Тип дії'
                value={getWorkPlaceTypeWork(result.typeWork)}
            />
        </div>

        {
            // result.typeWork === 'start' ?
            open ?
                <UserWorkPlaceConfirm 
                    scaned={result.scaned}
                    type={result.type}
                    setOpen={setOpen}
                />
            : ''
        }
    </div>
  )
}

export default UserWorkPlaceResult